import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const fucsSection = document.querySelectorAll('.featured-use-case-section');

    fucsSection.forEach(section => {
        const fucsThumbSliderEl = section.querySelector('.fucs-img-slider');
        const fucsMainSliderEl = section.querySelector('.fucs-content-slider');

        const isMobile = window.innerWidth < 768;

        // Thumbnail slider
        const fucsThumbSlider = new Swiper(fucsThumbSliderEl, {
            slidesPerView: 1,
            spaceBetween: 16,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            allowTouchMove: isMobile, // Enable swipe on mobile
        });

        // Main content slider
        const fucsMainSlider = new Swiper(fucsMainSliderEl, {
            slidesPerView: 1,
            spaceBetween: 16,
            effect: 'fade',
            autoHeight: true,
            fadeEffect: {
                crossFade: true,
            },
            thumbs: isMobile ? {} : { swiper: fucsThumbSlider }, // Only link on desktop
            allowTouchMove: isMobile, // Allow swipe on mobile
            navigation: {
                prevEl: section.querySelector('.fucs-arrow-prev'),
                nextEl: section.querySelector('.fucs-arrow-next'),
            },
        });

        // On mobile, manually sync thumb to main
        if (isMobile) {
            fucsThumbSlider.on('slideChange', () => {
                fucsMainSlider.slideTo(fucsThumbSlider.activeIndex);
            });
            fucsMainSlider.on('slideChange', () => {
                fucsThumbSlider.slideTo(fucsMainSlider.activeIndex);
            });
        }
    });
});
